import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DefaultForm, DirectorForm, DirectorLeadFIO, LeadFIO } from 'Pages/ibro'

export type BgSignatorySlice = {
	defaultForm: DefaultForm
	directorForm: DirectorForm
	leadFIO: LeadFIO
	directorLeadFIO: DirectorLeadFIO
}

export const BgSignatoryInitialState: BgSignatorySlice = {
	defaultForm: new DefaultForm(),
	directorForm: new DirectorForm(),
	leadFIO: new LeadFIO(),
	directorLeadFIO: new DirectorLeadFIO(),
}

export namespace BgSignatoryNs {
	export type SetDefaultForm = PayloadAction<DefaultForm>
	export type SetDirectorForm = PayloadAction<DirectorForm>
	export type SetLeadFIO = PayloadAction<LeadFIO>
	export type SetDirectorLeadFIO = PayloadAction<DirectorLeadFIO>
}

export const bgSignatorySlice = createSlice({
	name: 'bgSignatory',
	initialState: BgSignatoryInitialState,
	reducers: {
		setDefaultForm: (state, action: BgSignatoryNs.SetDefaultForm) => {
			state.defaultForm = action.payload
		},
		setDirectorForm: (state, action: BgSignatoryNs.SetDirectorForm) => {
			state.directorForm = action.payload
		},
		setLeadFIO: (state, action: BgSignatoryNs.SetLeadFIO) => {
			state.leadFIO = action.payload
		},
		setDirectorLeadFIO: (state, action: BgSignatoryNs.SetDirectorLeadFIO) => {
			state.directorLeadFIO = action.payload
		},
	},
})
